/**
 * Booking system configuration constants.
 * Replaces hardcoded magic numbers throughout CartContext and consumers.
 */

// ============================================
// APPOINTMENT TYPES (Booking Flow)
// ============================================
export const APPOINTMENT_TYPES = {
  SINGLE: 1,     // Single booking (one guest, services shared)
  GROUP: 2,      // Group booking (multiple guests, services per-guest)
};

// ============================================
// OUTLET TYPES (Location Classifications)
// ============================================
export const OUTLET_TYPES = {
  CLASSIC: 1,    // Classic outlet tier
  PREMIUM: 2,    // Premium outlet tier (default)
  PLUS: 5,       // Plus outlet tier (member rates behave like Classic)
};

// ============================================
// GUEST & SERVICE LIMITS
// ============================================
export const MAX_GUESTS = 4;
export const MAX_SERVICES_PER_GUEST = 3;

export const resolveMaxServiceCount = (value) => {
  const limit = Number(value);
  return Number.isInteger(limit) && limit > 0
    ? limit
    : MAX_SERVICES_PER_GUEST;
};

// Deprecated: kept for backward compatibility
export const maxGuestCount = MAX_GUESTS;
export const maxServiceCount = MAX_SERVICES_PER_GUEST;

// ============================================
// BOOKING SESSION
// ============================================
// export const DEPOSIT_AMOUNT = 20;  // SGD; fixed deposit at booking
export const DEFAULT_OUTLET_TYPE = OUTLET_TYPES.PREMIUM;

// ============================================
// TIMER (Slot Hold Duration)
// ============================================
// Hold countdown duration comes from web-settings `timerValue` (minutes).
export const TIMER_EXTENSION_SECONDS = 300;              // 5 min per extension
export const TIMER_EXTENSION_LIMIT = 2;                  // Max extensions allowed

// ============================================
// TIMEZONE & DATE FORMATTING
// ============================================
export const BOOKING_TIMEZONE = 'Asia/Singapore';
export const DATE_FORMAT = 'dd-mm-yyyy';  // Used in date storage

// ============================================
// COMPOSITE CONFIGS (for convenience)
// ============================================
export const BOOKING_CONFIG = {
  MAX_GUESTS,
  MAX_SERVICES_PER_GUEST,
  // DEPOSIT_AMOUNT,
  DEFAULT_OUTLET_TYPE,
  TIMER_EXTENSION_SECONDS,
  TIMER_EXTENSION_LIMIT,
  BOOKING_TIMEZONE,
};
